export default "__VITE_ASSET__CzEzaLyO__"